import { createApp } from 'vue'
import { createPinia } from 'pinia';
import App from './App.vue'
import router from './router';
import axios from 'axios';

// Setup global axios interceptor
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            console.warn('Authentication error, redirecting to login...');
            localStorage.removeItem('jwtToken');
            // Use router instance to redirect
            router.push('/login');
        }
        return Promise.reject(error);
    }
);

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(router);
app.mount('#app');
